export default "__VITE_ASSET__CL9bAz2z__"